import React from 'react';
import classnames from 'classnames';
import { default as Icon } from '../../../images/icon/28-2_delete.svg';
import SVG from 'react-inlinesvg';

type IconProps = {
  className?: string;
};
const Delete: React.FC<IconProps> = props => <SVG src={Icon} className={classnames(props.className, 'icon')} />;
export default Delete;
